export default "__VITE_ASSET__DzH_OMDo__"